import React from 'react'
import { useIntl } from 'react-intl'
import Tooltip from 'LuxKit/Tooltip'
import { OFFER_TYPE_TOUR } from 'constants/offer'
import SecureWithDepositTag from './SecureWithDepositTag'
import { isTourV2OfferType } from 'lib/offer/offerTypes'

interface Props {
  offerType: App.OfferType
  depositAmountPercentage?: number
}

function SecureWithDepositTagAndTooltip(props: Props) {
  const { offerType, depositAmountPercentage } = props
  const intl = useIntl()
  const tagTooltip = offerType === OFFER_TYPE_TOUR || isTourV2OfferType(offerType) ?
      intl.formatMessage({
        id: '1DNTtVKfVbIlJjqqo9U6',
        defaultMessage: 'Some departures available for you to secure with a deposit',
        description: 'Tooltip text explaining deposit availability for tour departures',
      }) : intl.formatMessage({
        id: 'c3nJuM6tNWEFyvOHSKhL',
        defaultMessage: 'Some packages available for you to secure with a deposit',
        description: 'Tooltip text explaining deposit availability for packages',
      })

  return (
    <Tooltip
      placement="bottom"
      description={tagTooltip}
    >
      <SecureWithDepositTag depositAmountPercentage={depositAmountPercentage} />
    </Tooltip>
  )
}

export default React.memo(SecureWithDepositTagAndTooltip)
